import type { TextProps } from '@chakra-ui/react'
import { Text } from '@chakra-ui/react'

export const StatLabel = ({ children, sx, ...rest }: TextProps) => {
  return (
    <Text sx={{ fontSize: 'sm', ...sx }} {...rest}>
      {children}
    </Text>
  )
}
